import { Palette } from '@mui/material'

export const navMenuButtonStyles = {
	flexGrow: 0,
	':hover': {
		backgroundColor: 'transparent',
	},
}

export const navMenuTextStyles = (palette: Palette, active: boolean) => ({
	span: {
		color: active ? palette.text.darkBlue : palette.text.lightGrey,
		fontWeight: active ? 'bold' : 'normal',
		textDecoration: active ? 'underline' : 'none',
		textUnderlineOffset: '10px',
	},
})
